<template>
    <div class="page_mobile_core flex-col">
        <div class="group_2 flex-col">
            <div class="text-group_7 flex-col">
                <span class="text_28">核心业务</span>
                <span class="text_29">
                    自主研发的3C企业健康管理服务体系，深入洞察医药企业上市产品全生命周期的风险与合规管理，助力企业实现可持续发展。
                </span>
            </div>
            <div class="list_1 flex-col">
                <div
                        class="list-items_1 flex-row justify-between"
                        :style="{ background: item.lanhuBg0 ,height: item.isHovered ? itemHeight.expanded : itemHeight.normal }"
                        v-for="(item, index) in loopData0"
                        :key="index"
                >
                    <div class="top-section">
                        <div class="image-text_2 flex-row justify-between">
                            <img class="image_9" referrerpolicy="no-referrer" :src="item.lanhuimage0" />
                            <div class="text-group_9 flex-col">
                                <span  class="text_34">{{item.title}}</span>
                                <div class="text-wrapper_7">
                                    <span class="text_35" v-html="item.lanhutext0"></span>
                                    <span class="text_36" v-html="item.lanhutext1"></span>
                                </div>
                            </div>
                        </div>
                        <div class="text-wrapper_8 flex-col" @click="handleClick(index)"><span class="text_38" v-html="item.clickName"></span></div>
                        <div class="box_12 flex-col" :style="{ background: item.lanhuBg4 }"></div>
                    </div>
                    <transition name="expand">
                        <div v-if="item.isHovered" class="detail-container">
                            <span class="detailInfo" v-html="item.detailInfo"></span>
                        </div>
                    </transition>
                </div>
            </div>
            <div class="core_div_content">
                <img
                        class="image_10"
                        referrerpolicy="no-referrer"
                        src="../../../assets/index/chpc_home_index_hx_10.png"
                />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                windowWidth: window.innerWidth,
                loopData0: [
                    {
                        title:'渠道风控管理',
                        lanhuBg0: 'rgba(27, 71, 93, 1)',
                        lanhuimage0: require('../../../assets/home/home_core_icon_01.png'),
                        lanhutext0: 'C',
                        lanhutext1: 'hannel',
                        lanhuBg4: require('../../../assets/home/home_core_icon_bj.png'),
                        clickName: '查看⽅案',
                        slot1: 1,
                        isHovered:false,
                        detailInfo:'作为医药领域渠道风控与合规管理服务的先行者之一，我们提供从常规核查到深度核查的创新风控管理解决方案，覆盖企业内部人员、经销商、药店及医院等多渠道多管理环节，助力客户破解渠道管理中的核心痛点。通过彻查问题并建立监督制约机制，提升销售数据的真实性和准确性，改善营销决策的有效性，优化渠道管理绩效，助力企业实现高效、透明的渠道运营与管理。',
                    },
                    {
                        title:'业务合规管理',
                        lanhuBg0: 'rgba(17,110,130,1.000000)',
                        lanhuimage0: require('../../../assets/home/home_core_icon_02.png'),
                        lanhutext0: 'C',
                        lanhutext1: 'ompliance',
                        lanhuBg4: require('../../../assets/home/home_core_icon_bj.png'),
                        clickName: '查看⽅案',
                        slot1: 1,
                        isHovered:false,
                        detailInfo:'面对医药大健康行业日益复杂的监管环境与多元化营销场景，康柏汉森为企业提供全链条、多维度的合规风控解决方案，覆盖费用审核、活动核查、合规审核等关键场景。支持全国范围内的突击核查，定制化风控核查的需求，助力客户降低合规风险、从容应对政策高压与市场挑战。',
                    },
                    {
                        title:'企业健康咨询',
                        lanhuBg0: 'rgba(0,120,126,1.000000)',
                        lanhuimage0: require('../../../assets/home/home_core_icon_03.png'),
                        lanhutext0: 'C',
                        lanhutext1: 'onsultation',
                        lanhuBg4: require('../../../assets/home/home_core_icon_bj.png'),
                        clickName: '查看⽅案',
                        slot2: 2,
                        isHovered:false,
                        detailInfo:'依托近二十年、100余家药械及大健康行业客户服务经验，我们为销售、商务、运营、采购、财务和内控等多部门提供全生命周期风控与企业健康咨询服务。通过日益积累的行业洞察与风险防控经验，帮助厘清运营规则，优化风险防范与控制策略，助力企业在政策高压、竞争加剧的复杂环境中实现稳健可持续发展。',
                    }
                ],
            };
        },
        computed: {
            itemHeight() {
                if (this.windowWidth <= 430) {
                    return {
                        normal: '80px',
                        expanded: '220px'
                    };
                }else if (this.windowWidth <= 480) {
                    return {
                        normal: '80px',
                        expanded: '260px'
                    };
                } else {
                    return {
                        normal: '130px',
                        expanded: '300px'
                    };
                }
            }
        },
        mounted() {
            window.addEventListener('resize', this.handleResize);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.handleResize);
        },
        methods: {
            handleClick(index){
                if(this.loopData0[index].isHovered){
                    this.loopData0[index].isHovered = false;
                    this.loopData0[index].clickName = '查看⽅案';
                }else{
                    this.loopData0[index].isHovered = true;
                    this.loopData0[index].clickName = '收起详情';
                }
            }
        }
    };
</script>

<style scoped lang="css">
    .page_mobile_core {
        background-color: rgba(255, 255, 255, 1);
        position: relative;
        max-width: 1200px;
        overflow: hidden;
        margin: 0 auto;
    }

    .group_2 {
        width: 100%;
        max-width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 auto;
        padding-top: 20px;
    }

    .text-group_7 {
        width: 100%;
        align-self: center;
        padding: 0;
        margin: 0 auto;
        text-align: center;
    }

    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .text_28 {
        width: 100%;
        overflow-wrap: break-word;
        color: rgba(18, 20, 28, 1);
        font-size: 38px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        line-height: 53px;
        align-self: center;
        max-width: 100%;
        text-align: center;
        white-space: normal;
        margin: 0 auto;
    }

    .text_29 {
        width: 100%;
        max-width: 700px;
        overflow-wrap: break-word;
        color: #666666;
        font-size: 20px;
        text-align: center;
        line-height: 28px;
        margin-top: 5px;
        margin-bottom: 10px;
        padding-left: 40px;
        padding-right: 40px;
        box-sizing: border-box;
    }

    .list_1 {
        width: 100%;
        align-self: center;
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .list-items_1 {
        position: relative;
        border-radius: 10px;
        max-width: 670px;
        width: 95vw;
        margin-bottom: 20px;
        transition: height 0.3s ease;
        overflow: hidden;
    }

    .top-section {
        height: 130px;
    }

    .image-text_2 {
        width: 244px;
        height: 72px;
        margin: 30px 0 24px 0;
    }

    .image-text_2.justify-between {
        display: flex;
        justify-content: space-between;
    }

    .image-text_2.flex-row {
        display: flex;
        flex-direction: row;
    }

    .image_9 {
        width: 72px;
        height: 72px;
        margin-left: 10px;
    }

    .text-group_9 {
        position: relative;
        width: 152px;
        height: auto;
        margin: 1px 0 1px 0;
        padding: 30px 53px 0 0;
        text-align: left;
    }

    .text_34 {
        position: absolute;
        left: 20px;
        top: -2px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 25px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 36px;
    }

    .text-wrapper_7 {
        width: auto;
        height: 40px;
        overflow-wrap: break-word;
        font-size: 0;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 40px;
        margin-left: 20px;
    }

    .text_35 {
        width: 106px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 28px;
        opacity: 0.6;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 40px;
    }

    .text_36 {
        width: 106px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        opacity: 0.6;
        font-size: 16px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        line-height: 40px;
    }

    .box_12 {
        background-size: 100% 100%;
        position: absolute;
        right: 0;
        bottom: 0;
        width: 77px;
        height: 119px;
        z-index: 1;
    }

    .text-wrapper_8 {
        position: absolute;
        right: 22px;
        top: 41px;
        background: url(../../../assets/home/home_core_bnt_bj.png) 0px 0px no-repeat;
        background-size: 153px 38px;
        padding: 8px 41px 8px 41px;
    }

    .detail-container {
        position: absolute;
        top: 90px;
        left: 0px;
        right: 31px;
        width: 100%;
        box-sizing: border-box;
    }

    .expand-enter-active {
        transition:
                opacity 0.3s ease,
                transform 0.3s ease;
    }

    .expand-leave-active {
        transition:
                opacity 0.2s ease,
                transform 0.2s ease;
    }

    .expand-enter-from,
    .expand-leave-to {
        opacity: 0;
        transform: translateY(-10px);
    }

    .detailInfo {
        display: block;
        width: 100%;
        color: rgba(255, 255, 255, 0.9);
        font-size: 16px;
        text-align: justify;
        border-radius: 8px;
        transition: all 0.3s ease;
        white-space: normal;
        word-break: break-word;
        padding: 1.5em 2em;
        line-height: 1.8em;
        box-sizing: border-box;
    }

    .text_38 {
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 18px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: center;
        white-space: nowrap;
        line-height: 25px;
    }

    .core_div_content {
        margin-top: 20px;
        width: calc(100% - 40px);
        display: flex;
        justify-content: center;
        margin-left: auto;
        margin-right: auto;
        max-width: 689px;
    }

    .image_10 {
        max-width: 100%;
        height: auto;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        overflow: hidden;
        transition: transform 0.3s ease;
        transform-origin: center center;
        transform-box: border-box;
    }

    @media (max-width: 480px) {
        .group_2 {
            width: 100%;
            padding-left: 15px;
            padding-right: 15px;
            box-sizing: border-box;
        }

        .text-group_7 {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-left: 0;
            padding-right: 0;
        }

        .text_29 {
            font-size: 12px;
            line-height: 1.5;
            padding-left: 10px;
            padding-right: 10px;
        }

        .text_28 {
            font-size: 25px;
            white-space: normal;
            line-height: 1.3;
            margin-left: 0;
        }

        .list-items_1 {
            width: 100%;
            padding-left: 0;
            height: 80px;
            max-width: 100%;
        }

        .top-section {
            height: 80px;
        }

        .image-text_2 {
            height: 50px;
            margin: 15px 0;
        }

        .image_9 {
            width: 40px;
            height: 40px;
            margin-left: 20px;
            margin-right: 10px;
        }

        .text-group_9 {
            position: relative;
            width: calc(100% - 60px);
            margin-left: 8px;
            padding: 0;
        }

        .text_34 {
            position: static;
            display: block;
            margin-bottom: 4px;
            font-size: 16px;
            line-height: 1.2;
            white-space: normal;
        }

        .text-wrapper_7 {
            height: 24px;
            line-height: 24px;
            text-align: left;
            margin-left: 0;
            padding-left: 0;
            width: auto;
            display: block;
        }

        .text_35 {
            font-size: 16px;
            line-height: 24px;
        }

        .text_36 {
            font-size: 10px;
            line-height: 24px;
        }

        .text_35, .text_36 {
            display: inline;
            font-size: 14px;
            line-height: 1.2;
            white-space: normal;
        }

        .box_12 {
            width: 40px;
            height: 60px;
        }

        .text-wrapper_8 {
            position: absolute;
            right: 22px;
            top: 30px;
            background: url(../../../assets/home/home_core_bnt_bj.png) 0px 0px no-repeat;
            background-size: 80px 25px;
            padding: 4px 20px 4px 20px;
        }

        .text-wrapper_8:active {
            transform: scale(0.95);
        }

        .text_38 {
            font-size: 12px;
            white-space: nowrap;
            line-height: 20px;
        }

        .detail-container{
            position: absolute;
            top: 60px;
            left: 0px;
            right: 31px;
            width: 100%;
            box-sizing: border-box;
        }

        .detailInfo {
            font-size: 12px;
            line-height: 1.5;
            padding: 1em;
        }

        .core_div_content {
            margin: 15px auto 0;
            width: 100%;
            max-width: 100%;
            padding: 0 15px;
            box-sizing: border-box;
        }

        .image_10 {
            max-width: 100%;
        }
    }
</style>
